<template>
  <div class="container">
    <h2>Gestion des projets</h2>
    <hr>
    <div class="form-row">
      <div class="form-group col-sm-3">
        <kez-input :label="'Nom du client'" v-model="clientName" validate="required"/>
      </div>
      <div class="form-group col-sm-3">
        <kez-input :label="'Nom du projet'" v-model="projectName" validate="required"/>
      </div>
      <div class="form-group col-sm-3">
        <kez-select
          :label="'Statut'"
          v-model="project.typeGuid"
          :options="formattedProjectStatusTypes"
          validate="required"
        />
      </div>
      <div class="addBtn form-group col-sm-3 float-right">
        <button v-if="isAdd" type="submit" class="btn btn-action" @click="add(project)">Ajouter</button>
      </div>
    </div>

    <div class="border-top mt-3">
      <br>
      <div class="form-row">
        <div class="search-wrapper form-group col-sm-8">
          <h3>Liste des projets</h3>
        </div>
        <!-- SEARCH -->
        <div class="search-wrapper form-group col-sm-4">
          <input type="search" v-model="search" placeholder="Nom">
          <button type="submit" class="btn btn-action btn-sm" v-on:click="resetFields()">
            <i class="material-icons">cancel</i>
          </button>
        </div>
      </div>
      <!-- -->
      <table class="table table-striped mt-3">
        <thead>
          <tr>
            <th>Nom du client</th>
            <th>Nom du projet</th>
            <th>Statut</th>
            <th>Actif</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(project,index) in filteredList" :key="index">
            <td>
              <input type="string" v-model="project.clientName" v-bind:disabled="project.disabled">
            </td>
            <td>
              <input type="string" v-model="project.name" v-bind:disabled="project.disabled">
            </td>
            <td>
              <kez-select
                :noLabelDisplayed="true"
                :label="'Type'"
                v-model="project.typeGuid"
                :options="formattedProjectStatusTypes"
                validate="required"
                v-bind:disabled="project.disabled"
              />
            </td>
            <td>
              <div class>
                <toggle-button
                  @change="changeStatus(project)"
                  :value="project.isActive"
                  :sync="true"
                  v-bind:disabled="project.disabled "
                />
              </div>
            </td>
            <td>
              <router-link
                :to="{ name: 'Project',
                       query: {
                         id: project.projectGuid
                       }
                }"
                class="btn btn-outline-primary"
              >Voir les requis</router-link>
              <router-link
                :to="{ name: 'Resume',
                       query: {
                         id: project.projectGuid
                       }
                }"
                class="btn btn-outline-primary"
              >Voir le résumé</router-link>
              <router-link
                :to="{ name: 'ProjectDetails',
                       query: {
                         id: project.projectGuid
                       }
                }"
                class="btn btn-outline-primary"
              >Détails</router-link>
            </td>
            <td>
              <div v-show="project.disabled" class="inline">
                <button type="submit" class="btn btn-action btn-sm" @click="edit(project)">
                  <i class="material-icons">edit</i>
                </button>
                <button
                  type="submit"
                  class="btn btn-action btn-sm inline"
                  @click="remove(project.projectGuid)"
                >
                  <i class="material-icons">delete</i>
                </button>
              </div>

              <div v-show="!project.disabled" class="inline">
                <button type="submit" class="btn btn-action btn-sm inline" @click="cancel(project)">
                  <i class="material-icons">cancel</i>
                </button>
                
                <button type="submit" class="btn btn-action btn-sm inline" @click="save(project)">
                  <i class="material-icons">done</i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <kez-confirm-modal
        v-model="openModalDelete"
        :title="'Supprimer un projet'"
        :message="'Êtes-vous sur de vouloir supprimer ce projet?'"
        @confirm="deleteProject()"
      />
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import KezInput from "@/components/_forms/KezInput";
import KezConfirmModal from "@/components/_modals/KezConfirmModal";
import KezSelect from "@/components/_forms/KezSelect";
import Search from "@/components/search/Search";

export default {
  components: {
    KezInput,
    KezConfirmModal,
    Search,
    KezSelect
  },
  data() {
    return {
      isAdd: true,
      openModalDelete: false,
      selectedProject: null,
      isEdit: false,
      search: "",
      clientName: "",
      projectName: ""
    };
  },
  computed: {
    filteredList() {
      return this.projects.filter(project => {
        if (
          project.name.toLowerCase().includes(this.search.toLowerCase()) ||
          project.clientName.toLowerCase().includes(this.search.toLowerCase())
        )
          return project;
      });
    },
    ...mapState("projects", ["projects", "project"]),
    ...mapGetters("projectStatusTypes", [
      "formattedProjectStatusTypes",
      "formattedProjectStatus"
    ])
  },
  watch: {},
  mounted() {
    this.$store.commit("projects/project", {});
    this.$store.dispatch("projects/getList");
    this.$store.dispatch("projectStatusTypes/getList");
  },
  methods: {
    add() {
      this.isEdit = true;
      if (
        this.clientName != null &&
        this.projectName != null &&
        this.project.typeGuid != null
      ) {
        this.project.name = this.projectName;
        this.project.clientName = this.clientName;
        this.$store.dispatch("projects/save", this.project);
        this.projet = {};
        this.clientName = "";
        this.projectName = "";
      }
    },
    deleteProject() {
      this.$store.dispatch("projects/delete", this.selectedProject);
    },

    remove(index) {
      this.selectedProject = index;
      this.openModalDelete = true;
    },
    edit(project) {
      if (project.disabled == undefined) {
        project.disabled = true;
      } else {
        project.disabled = project.disabled == true ? false : true;
      }
      project.oldValue = {
        typeGuid: project.typeGuid,
        clientName: project.clientName,
        name: project.name,
        IsActive: project.IsActive
      };
      this.project;
    },
    completeEdit() {
      this.$store.dispatch("projects/save", this.project);
      this.isAdd = true;
    },
    cancel(project) {
      project.disabled = true;
      project.typeGuid = project.oldValue.typeGuid;
      project.name = project.oldValue.name;
      project.clientName = project.oldValue.clientName;
      project.isActive = project.oldValue.isActive;
    },
    save(project) {
      this.isEdit = true;
      const newProject = project;
      this.$store.dispatch("projects/save", { project: newProject });
    },
    changeStatus(project) {
      this.isEdit = true;
      project.isActive = project.isActive == true ? false : true;
    },
    resetFields() {
      this.search = "";
    }
  }
};
</script>

<style>
.addBtn {
  margin-top: 38px;
}
.headerTask {
  margin-top: 30px;
}
</style>
